import * as React from 'react';
import { Card, Row, Col, Form, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { RootState } from '@src/app/_redux';
import { actionCreators } from '@src/app/login/weak/emailpostalcode/actions';
import { Field, reduxForm } from 'redux-form';
import { TextInput } from '@src/app/_global/components/form-elements';
import { required, email, noSpaces, alphaNumeric } from '@src/app/_global/field-validations';
import { getSocialEmail } from '@src/app/login/selectors';
import CardBody from 'reactstrap/lib/CardBody';
import ReCAPTCHA from 'react-google-recaptcha';
import { getProdIdsForGlobalCodeFromAdminConfig } from '@src/app/accounts/selectors';

interface Props {
  onSubmitHandler: Function;
  handleSubmit: Function;
  initialize: Function;
  submitting: boolean;
  socialEmail: string;
  pristine: boolean;
  intl: intlShape;
  signInData: any;
  productExcludes: any;
}

interface State {
  disableSubmitBtn: boolean;
}

export class EmailPostalCodeLoginForm extends React.Component<Props> {
  state: State = {
    disableSubmitBtn: true,
  };

  constructor(props: Props) {
    super(props);
  }

  recaptchaSuccess = (value: string) => {
    // If no value, the reCaptcha has timed out.  Disable the submit button until user rechecks reCaptcha.
    this.setState({
      disableSubmitBtn: value ? false : true,
    });
  }

  formatLabels = (messageId, descriptionm, defaultm, context) => {
    return this.props.intl.formatMessage({
      id: messageId,
      description: descriptionm,
      defaultMessage: defaultm,
    });
  }

  componentDidMount() {
    this.initializeForm();
  }

  initializeForm() {
    const { socialEmail, productExcludes } = this.props;
    if (socialEmail) {
      this.props.initialize({ email: socialEmail, productExcludes: productExcludes });
    }
  }

  // tslint:disable-next-line:member-ordering
  emailAddLabel = this.formatLabels(
    'app.emailadd',
    'Email address label',
    'Email*',
    this.context,
  );
  // tslint:disable-next-line:member-ordering
  postLabel = this.formatLabels(
    'app.postal',
    'Postal code label',
    'ZIP/Postal Code*',
    this.context,
  );
  public render() {
    const { handleSubmit, onSubmitHandler, signInData } = this.props;

    let disableSubmitBtn = false;
    if (signInData.RecaptchaEnabled) {
      // recaptcha enabled.  Let local state determine if we show the button or not.
      disableSubmitBtn = this.state.disableSubmitBtn;
    }

    return (
      <React.Fragment>
      {this.props.signInData.EmailPostalCodeEnabled  && (
      <Form
        inline={true}
        id="login-form"
        onSubmit={handleSubmit(onSubmitHandler)}
      >
        <Card>
          <CardBody>
            <Row>
              <Col className="mb-2" xs={12} sm={12} md={12} lg={6}>
                <Field
                  id="login-email-add"
                  label={this.emailAddLabel}
                  className="weak-login-input-field"
                  name="email"
                  validate={[required, email]}
                  component={TextInput}
                  type="text"
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={6}>
                <Field
                  id="login-pc-b"
                  label={this.postLabel}
                  className="weak-login-input-field"
                  name="postalCode"
                  validate={[required, noSpaces, alphaNumeric]}
                  component={TextInput}
                  type="text"
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            { signInData.RecaptchaEnabled &&
              (
                <Row>
                  <Col>
                    <ReCAPTCHA className="flexContainer mt-3 mb-2 recaptcha"
                      sitekey="6LcQ14YUAAAAAKsWbAnGKL3Dh7BNEyIbMKUeplOV"
                      onChange={this.recaptchaSuccess}
                    />
                  </Col>
                </Row>
              )
            }
            <Row>
              <Col>
                <button className="btn btn-primary" type="submit" disabled={disableSubmitBtn}>
                  <FormattedMessage
                    id="app.btnfindacnt"
                    defaultMessage={'Find Your Account'}
                  />
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Form>
      )}
      </React.Fragment>
    );
  }
}

const form = reduxForm({
  form: 'login-form-email',
})(EmailPostalCodeLoginForm);

const mapStateToProps = (state: RootState) => ({
  socialEmail: getSocialEmail(state),
  productExcludes: getProdIdsForGlobalCodeFromAdminConfig(state),
  initialValues: {
    'productExcludes': getProdIdsForGlobalCodeFromAdminConfig(state),
  }
});

export const EmailPostalCodeLogin = injectIntl(
  connect(
    mapStateToProps,
    {
      onSubmitHandler: actionCreators.emailPostalCodeLogin,
    },
  )(form),
);
